<template>
	<div class="blog-wrapper">
		<NothingHere v-if="!blogPosts || blogPosts.length === 0"
		             class="nothing-here" />
	</div>
</template>
<script>
import NothingHere from '@/assets/empty.vue';
export default {
	components: {
		NothingHere,
	},
	data: () => ({
		blogPosts: null
	})
}
</script>
<style lang="scss">
.blog-wrapper {
	padding: 20px;
}

.nothing-here {
	margin: 20px auto;
	max-width: 250px;
}
</style>